import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ToastService } from '../services/toast.service';

@Component({
  selector: 'app-toast-host',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './toast-host.html',
})
export class ToastHost {
  protected readonly toast = inject(ToastService);

  protected icon(type: string): string {
    switch (type) {
      case 'error':
        return '⚠️';
      case 'info':
        return 'ℹ️';
      default:
        return '✅';
    }
  }

  protected accent(type: string): string {
    switch (type) {
      case 'error':
        return 'border-l-red-500';
      case 'info':
        return 'border-l-blue-500';
      default:
        return 'border-l-emerald-500';
    }
  }
}
